import { useEffect, useState } from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import Input from '../components/Input';
import { crmService } from '../services/crmService';
import { useToast } from '../store/toastContext';
import type { SettingsData } from '../types';

const initial: SettingsData = {
  api_key_serp: '1988402dc48b4118eaa8db031a4dba1e281e20bae426158b83d4926d31a73e35',
  phone_agente: '+5511999999999',
  api_key_apolo: 'XCDqk_o0PXHSIiX_nhbM1Q',
  apikey: '429683C4C977415CAAFCCE10F7D57E11',
  instance_name: 'DOMINA FOOD',
  google_calendarid: ''
};

export default function ConfiguracoesPage() {
  const [form, setForm] = useState<SettingsData>(initial);
  const [loading, setLoading] = useState(false);
  const { pushToast } = useToast();

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      try {
        const remote = await crmService.getSettings();
        if (!active) return;
        setForm({
          ...initial,
          api_key_serp: remote.api_key_serp?.trim() || initial.api_key_serp,
          api_key_apolo: remote.api_key_apolo?.trim() || initial.api_key_apolo,
          apikey: remote.apikey?.trim() || initial.apikey,
          instance_name: remote.instance_name?.trim() || initial.instance_name,
          google_calendarid: remote.google_calendarid?.trim() || ''
        });
      } catch {
        if (!active) return;
        setForm(initial);
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, []);

  const save = async () => {
    const next: SettingsData = {
      ...form,
      api_key_serp: form.api_key_serp.trim(),
      api_key_apolo: form.api_key_apolo.trim(),
      apikey: form.apikey.trim(),
      instance_name: form.instance_name.trim(),
      google_calendarid: form.google_calendarid.trim()
    };

    if (!next.api_key_apolo || !next.apikey || !next.instance_name) {
      pushToast({ type: 'error', title: 'Preencha os campos obrigatorios.' });
      return;
    }

    setLoading(true);
    try {
      await crmService.updateSettings(next);
      setForm(next);
      pushToast({ type: 'success', title: 'Configuracoes atualizadas com sucesso.' });
    } catch {
      pushToast({ type: 'error', title: 'Nao foi possivel salvar as configuracoes.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-black">Configuracoes</h1>
      <Card className="space-y-3">
        {/* <Input label="api_key_serp" value={form.api_key_serp} onChange={(e) => setForm((p) => ({ ...p, api_key_serp: e.target.value }))} /> */}
        <Input label="api_key_apolo" value={form.api_key_apolo} onChange={(e) => setForm((p) => ({ ...p, api_key_apolo: e.target.value }))} />
        <Input label="api key evolution" value={form.apikey} onChange={(e) => setForm((p) => ({ ...p, apikey: e.target.value }))} />
        <Input label="Nome da instancia" value={form.instance_name} onChange={(e) => setForm((p) => ({ ...p, instance_name: e.target.value }))} />
        <Input label="ID do Google Agenda" value={form.google_calendarid} onChange={(e) => setForm((p) => ({ ...p, google_calendarid: e.target.value }))} />
        <Button variant="primary" onClick={save} disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar configuracoes'}
        </Button>
      </Card>
    </div>
  );
}
